const LOCAL_STORAGE_CHANGE_EVENT = "gv:onLocalStorageChange";
export {
  LOCAL_STORAGE_CHANGE_EVENT
};
//# sourceMappingURL=events.js.map
